import { useEffect, useRef } from 'react'
import { Quote } from 'types/payments'

interface UseCountdownRestartProps {
  quote: Quote
  resetTimer: () => void
  timeLeft: number
}

export const useCountdownRestart = ({ resetTimer, quote, timeLeft }: UseCountdownRestartProps) => {
  const lastExpiryDateRef = useRef<number | undefined>(undefined)

  useEffect(() => {
    if (quote?.acceptanceExpiryDate && quote.acceptanceExpiryDate !== lastExpiryDateRef.current) {
      lastExpiryDateRef.current = quote.acceptanceExpiryDate
      resetTimer()
    }
  }, [quote?.acceptanceExpiryDate, resetTimer])

  useEffect(() => {
    if (timeLeft) return

    resetTimer()
  }, [timeLeft, resetTimer])
}
